import React from 'react';
import PropTypes from 'prop-types';
import Helper from '../../../helpers/Helper';
import * as styles from './style';

const MenuListHelper = ({ marketplaces, menus, customStyle }) => {
  const renderMarketplacesNames = menu => {
    return menu.marketplaces
      .filter(mktpc => {
        const marketplace = marketplaces.find(mktp => mktp.id === mktpc);
        return marketplace;
      })
      .map(mkt => {
        return marketplaces.find(mktpc => mktpc.id === mkt).name;
      })
      .join(', ');
  };
  return (
    <styles.MenuList style={customStyle}>
      {menus.map(menu => (
        <styles.MenuItem key={`new-menu-list-${menu.id}`}>
          <styles.MarketplacesName>{renderMarketplacesNames(menu)}</styles.MarketplacesName>
          <styles.MenuType>{Helper.formatServiceTypeNames(menu)}</styles.MenuType>
        </styles.MenuItem>
      ))}
    </styles.MenuList>
  );
};

MenuListHelper.propTypes = {
  menus: PropTypes.array,
  marketplaces: PropTypes.array,
  customStyle: PropTypes.object,
};

export default MenuListHelper;



// WEBPACK FOOTER //
// ./src/components/CreateMenuModal/MenuListHelper/index.js